import {buildScaleFromInterpolators, interpolatorsFrom, smooth} from "./palette.js";

export function createOMAODPalette(resolution = 3003) {

// 0.01 extremely clean air
// 0.15 US average
// 0.4 very hazy

    const bounds = [0.01, 3.5];  // units: τ
    const stops = [
        {color: [ 23,  79, 124], mode: "lab", p: bounds[0]},
        {color: [ 98, 155, 204], mode: "lab", p: 0.15},
        {color: [255, 255, 255], mode: "lab", p: 0.8},
        {color: [239, 169, 126], mode: "lab", p: 1.25},
        {color: [138, 106,   1], mode: "lab", p: 2.25},
        {color: [ 61,   0,  45], mode: "lab", p: bounds[1]},
    ];

    let interpolators = interpolatorsFrom(stops);
    interpolators = smooth(interpolators, 1, [0.7, 0.9]);
    return buildScaleFromInterpolators(bounds, interpolators, resolution);
}
